import { formatTokenAmountForDisplay } from "@/utils";
import { DialogContent, DepositForm, Divider, DialogAwareContentContainer } from "@/components";
import { TokenAmount } from "@/components";
import { TOKEN_IDS } from "@/types";
import { useUserTvl } from "@/hooks/infinifi/useUserTvl";

export type DepositMoreFormDialogProps = {};

export function DepositMoreFormDialog() {
    const { siUsdBalance } = useUserTvl();

    return (
        <DialogContent className="w-[480px] max-w-full">
            <DialogAwareContentContainer isDialog>
                <div className="flex justify-between items-center">
                    <div className="text-gray-400">Existing stake</div>
                    <TokenAmount amount={formatTokenAmountForDisplay(siUsdBalance)} tokenId={TOKEN_IDS.SIUSD} />
                </div>
                <Divider />
            </DialogAwareContentContainer>

            <DepositForm isDialog tokenInputLabel="Enter additional amount" />
        </DialogContent>
    );
}
